<template>
  <b-modal
    ref="modal"
    title-tag="div"
    :dialog-class="data.dialogClass"
    :content-class="data.contentClass"
    :body-class="data.bodyClass + ' p-0'"
    :size="data.size || 'md'"
    :title="data.title"
    :centered="data.centered || false"
    :scrollable="false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :hide-header-close="data.hideHeaderClose || false"
    header-text-variant="white"
    header-bg-variant="secondary"
    footer-bg-variant="secondary"
    cancel-variant="info"
    footer-class="d-none"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <component
      :is="data.dclass"
      v-if="opened"
      :variant="data.variant"
      :catalog="data.catalog"
      :model="data.model"
      :extra="data.extra"
      @update="selectValue"
      @cancel="closeModal"
    ></component>
  </b-modal>
</template>
<script>
    import dModalDClass from "@dialogs/modalDClass";

    export default {
        mixins: [dModalDClass]
    };
</script>



// WEBPACK FOOTER //
// src/custom/mepsaws/dialogs/modalDClass.vue